export const SessionTimeInMin = 60 * 12; // 12 hours
export const SessionTimeInMilliseconds = SessionTimeInMin * 60 * 1000;
